import { Component, Input, OnInit, Output,EventEmitter } from "@angular/core";

@Component({
  selector: "app-devis-succes-modal",
  templateUrl: "./devis-succes-modal.component.html",
  styleUrls: ["./devis-succes-modal.component.scss"],
  standalone: false,
})
export class DevisSuccesModal implements OnInit {

  @Input() image: string = "";
  @Input() message: string = "";
  @Input() title: string = "";
  @Input() validText: string = "";
  @Input() cancleText: string = "";
  @Input() cssClass: string = "";
  @Input() validLoading = false;
  @Input() cancelLoading = false;
  @Output() valid: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancle: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}

  get buttonsDisabled(): boolean {
    return this.validLoading || this.cancelLoading;
  }

  handleValid() {
    if (this.validLoading || this.buttonsDisabled) {
      return;
    }
    this.valid.emit();
  }
  handleCancle(){
    this.cancle.emit()
  }
  goBack() {
    // this.navController.back();
  }
}
